import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table, Modal} from 'react-bootstrap';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';

var Config = require('../../../config');

class ModalSampleDetails extends Component{
	constructor(props){
		super(props);
		this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.calcularEdad = this.calcularEdad.bind(this);

		this.state = {
            show: false,
            sample:{
                sample_types:{},
                convoke_places:{},
                person:{},
                address:{},
                analitical_test:[],
                document:{}
            },
            age:"",
            documents:[],
            civil_status_array:[],
            day_sessions:[]
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	handleShow(id){
        this.setState({show: true});

        fetch(Config.default.apiGateway.URL+'work_sessions/'+sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		}).then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error!', result, 'error');
	          });
        	}
    	}).then(response => {
			this.setState({
		      day_sessions: response
		    });
		});
        
        fetch(Config.default.apiGateway.URL+'samples/show?id='+id, {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(error) {
                swal('¡Error!', error, 'error');
              });
	        }
	    })
		.then(response =>{
			if(response !== undefined){
				this.calcularEdad(response.birthday);
	            this.setState({sample:response});
			}
	            
        })
        
        fetch(Config.default.apiGateway.URL+'lookups?type=document_type&notrender=0',{
			method: 'get',
			headers: new Headers({
			   	'Authorization' : 'Bearer ' + sessionStorage.getItem("token") , 
			   	'Accept' 		: 'application/json',
				'Content-Type' 	: 'application/json',
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal("Error", msg, 'error');
				});
			}
		}).then(response=>{
			if(response !== undefined){
				this.setState({documents:response});
			}
        })
        
        fetch(Config.default.apiGateway.URL+'lookups?type=CIVIL_STATUS&option=actives&order=true',{ 
		    method: 'get',
		    headers: new Headers({
		       	'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       	'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
		  	this.setState({civil_status_array: response});
        })
        
        fetch(Config.default.apiGateway.URL+'work_sessions/?option=&health_facilities_id='+sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		}).then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        	}
    	}).then(response => {
			this.setState({
                day_session_donation : response.id
              });
		});
	}

	handleClose(){
        this.setState({show: false,
            sample:{
                sample_types:{},
                convoke_places:{},
                person:{},
                address:{},
                analitical_test:[],
                document:{}
            },
            age:"",
        });
    }
    
    //calcular edad
	calcularEdad(fecha){
		var hoy = new Date();
	    var cumpleanos = new Date(fecha.split(/\//).reverse().join('/'));
	    if(cumpleanos.toString() !== 'Invalid Date'){
		    var edad = hoy.getFullYear() - cumpleanos.getFullYear();
		    var m = hoy.getMonth() - cumpleanos.getMonth();

		    if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
		        edad--;
		    }
		    this.setState({age:edad});
		}
	}

	render(){
		const {t} = this.props;

		return (
			<Modal show={this.state.show} onHide={this.handleClose} bsSize="large">
		       	<Modal.Header closeButton>
		        	<Modal.Title>Detalles Muestra</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{padding:"5px"}}>
                    <fieldset className="col-xs-12">
						<legend>Datos Donación</legend>
						<div className="col-xs-12 col-sm-2" style={{paddingRight:"0px"}}>
							<span className="span-min">{t('content.offers.form.timestamp')}</span>
							<input className="form-control" value={this.state.sample.timestamp || ""}  disabled />
				 		</div>

				 		<div className="col-xs-12 col-sm-2">
				        	<span className="span-min">{t('content.offers.form.day_session')}</span>
							<select className="form-control" name="day_session_donation" id="day_session_donation"
								value={this.state.day_session_donation} onChange={ this.handleChange }
								onKeyPress={this.state.validateInput} disabled>
				            	{this.state.day_sessions.map(function(t) {
				                	return <option  key={t.id}value={t.id} >
				                		{t.type_value} 
				                	</option>;
				                })}
				            </select>
				        </div>

						<div className="col-xs-12 col-sm-4">
							<span className="span-min">{t('content.offers.form.convoke_place')}</span>
							<input className="form-control" value={this.state.sample.convoke_places.name || ""} disabled />
				        </div>				        

				        <div className="col-xs-12 col-sm-4" style={{width:"21.8%"}}>
							<span className="span-min">Tipo de Muestra</span>
							<input className="form-control" value={this.state.sample.sample_types.name || ""} disabled />
						</div>

						<div className="col-xs-12 col-sm-4" style={{paddingRight:"0px", width:"11%"}}>
							<span className="span-min">No. Muestra</span>
							<input className="form-control" value={this.state.sample.number || ""} disabled />
				 		</div>
			        </fieldset>

			        <fieldset className="col-xs-12 form-group" >
						<legend>Datos del Donador</legend>
                        <div className="col-xs-12" style={{padding:"0px"}}>
                            <div className="col-xs-12 col-sm-2" >
                                <span className="span-min">{t('content.offers.form.document_type')}</span>
                                {this.state.sample.document!==null? <select className="form-control" value={this.state.sample.document.document_type} disabled> 
                                    {this.state.documents.map(function(t) {
                                        return <option key={t.id}  value={t.key} >
                                            {t.name} 
                                        </option>;
                                    })}
                                </select>:
                                <input className="form-control" disabled/>}
                            </div>
                            <div className="col-xs-12 col-sm-2" >
                                <span className="span-min">{t('content.offers.form.number')}</span>
                                <input className="form-control" disabled
                                    value={this.state.sample.document !== null?this.state.sample.document.document_number:""}  />
                            </div>
                            <div className="col-xs-12 col-sm-2" >
                                <span className="span-min">{t('content.offers.form.gender')}</span>
                                <input className="form-control" value={this.state.sample.person.sex} disabled/>
                            </div>
                            
                            <div className=" col-xs-12 col-sm-2" >
                                <span className="span-min">{t('content.offers.form.civil_status')}</span>
                                {<select className="form-control" value={this.state.sample.person.civil_status} disabled> 
                                    {this.state.civil_status_array.map(function(t) {
                                        return <option key={t.id}  value={t.key} >
                                            {t.name} 
                                        </option>;
                                    })}
                                </select>}
                            </div>

                            <div className=" col-xs-12 col-sm-4" style={{paddingLeft: 0}}>
                                <div className="form-group col-xs-12 col-sm-8" style={{marginBottom: 0}}>
                                    <span className="span-min">{t('content.offers.form.birthday')}</span>
                                    <input className="form-control" value={this.state.sample.birthday} disabled/>
                                </div>
                                <div className="form-group col-xs-12 col-sm-4" style={{paddingRight: 0,marginBottom: 0}}>
                                    <span className="span-min">{t('content.offers.form.age')}</span>
                                    <input className="form-control" value={this.state.age} disabled/>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-12" style={{padding:"0px"}}>
                            <div className=" col-xs-12 col-sm-4" >
                                <span className="span-min">{t('content.offers.form.names')}</span>
                                <input className="form-control" value={this.state.sample.person.names} disabled/>
                            </div>

                            <div className="col-xs-12 col-sm-2">
                                <span className="span-min">{t('content.offers.form.lastname1')}</span>
                                <input className="form-control" value={this.state.sample.person.lastname1} disabled/>
                            </div>

                            <div className="col-xs-12 col-sm-2" >
                                <span className="span-min">{t('content.offers.form.lastname2')}</span>
                                <input className="form-control" value={this.state.sample.person.lastname2} disabled/>
                            </div>

                            <div className="col-xs-12 col-sm-4" >
                                <span className="span-min">{t('content.offers.form.email')} </span>
                                <input className="form-control" value={this.state.sample.person.email} disabled/>
                            </div>

                            <div className="col-xs-12 col-sm-4" >
                                <span className="span-min">{t('content.offers.form.scholarship')} </span>
                                <input className="form-control" value={this.state.sample.person.scholarship} disabled/>
                            </div>
                            <div className="col-xs-12 col-sm-4" >
                                <span className="span-min">{t('content.offers.form.job_profile')}</span>
                                <input className="form-control" value={this.state.sample.person.job_profile} disabled/>
                            </div>
                        </div>

                        <div className="col-xs-12" style={{padding:"0px"}}>
                            <div className="col-xs-12" style={{padding:"0px"}}>
                                <div className="col-xs-12" >
                                    <span className="span-min">{t('content.generics.address.street')}</span>
                                    <input className="form-control" value={this.state.sample.address.street} disabled/>
                                </div>
                            </div>
                            <div className="col-xs-12" style={{padding:"0px"}}>
                                <div className="col-xs-12 col-sm-4" >
                                    <span className="span-min">{t('content.generics.address.postal_code')}</span>
                                    <input className="form-control" value={this.state.sample.address.postal_code} disabled/>
                                </div>
                                <div className=" col-xs-12 col-sm-4" >
                                    <span className="span-min">{t('content.generics.address.mpio')}</span>
                                    <input className="form-control" value={this.state.sample.address.municipio} disabled/>
                                </div>
                                <div className=" col-xs-12 col-sm-4" >
                                    <div >
                                        <span className="span-min">{t('content.generics.address.state')} </span>
                                        <input className="form-control" value={this.state.sample.address.estado} disabled/>
                                    </div>
                                </div>
                            </div>
                        </div>
					</fieldset>

					<fieldset className="col-xs-12 form-group">
                    <legend>Pruebas Analíticas</legend>
						<div className="col-xs-12">
							<div className="col-xs-12">
								<Table responsive hover>
									<tbody>
										{this.state.sample.analitical_test.map((list, i)=>{
											return (i+1 === 1) ?
												<tr key={i}>
													<td>{this.state.sample.analitical_test[i]!== undefined ?
															this.state.sample.analitical_test[i].name : ""}</td>
													<td>{this.state.sample.analitical_test[i+1] !== undefined ?
															this.state.sample.analitical_test[i+1].name : ""}</td>
													<td>{this.state.sample.analitical_test[i+2] !== undefined ?
															this.state.sample.analitical_test[i+2].name : ""}</td>
												</tr>
											: (i+1)%3 === 0 ?
												<tr key={i}>
													<td>{this.state.sample.analitical_test[i+1] !== undefined ? this.state.sample.analitical_test[i+1].name : ''}</td>
													<td>{this.state.sample.analitical_test[i+2] !== undefined ? this.state.sample.analitical_test[i+2].name : ''}</td>
													<td>{this.state.sample.analitical_test[i+3] !== undefined ? this.state.sample.analitical_test[i+3].name : ''}</td>
												</tr>
											:null
										})}
									</tbody>
								</Table>
							</div>
															
						</div>
					</fieldset>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>
		)
	}
} 

export default translate('translations') (ModalSampleDetails);